module.exports = __webpack_public_path__ + "img/p36.d1618861.jpg";